import { render, staticRenderFns } from "./NewPqr.vue?vue&type=template&id=ae7bf8cc&"
import script from "./NewPqr.vue?vue&type=script&lang=js&"
export * from "./NewPqr.vue?vue&type=script&lang=js&"
import style0 from "./NewPqr.vue?vue&type=style&index=0&id=ae7bf8cc&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports